import Header, {
  IHeaderProps
} from "components/common/PanelLayout/Header/Header";
import {
  Content,
  Wrapper
} from "components/common/PanelLayout/PanelLayout.style";
import React, { FunctionComponent } from "react";
import { ReactElement } from "react";

interface IProps extends IHeaderProps {
  panelPadding?: number;
  children?: ReactElement;
  centerContent?: boolean;
}

const PanelLayout: FunctionComponent<IProps> = ({
  title,
  titleSecondary,
  rightTitle,
  actionComponent,
  infoComponent,
  closeButtonHandler = false,
  backButtonHandler,
  children,
  clearSession,
  centerContent = false
}) => (
  <Wrapper>
    <Header
      title={title}
      titleSecondary={titleSecondary}
      rightTitle={rightTitle}
      closeButtonHandler={closeButtonHandler}
      backButtonHandler={backButtonHandler}
      actionComponent={actionComponent}
      infoComponent={infoComponent}
      clearSession={clearSession}
    />
    <Content centerContent={centerContent}>{children}</Content>
  </Wrapper>
);

export default PanelLayout;



// WEBPACK FOOTER //
// ./src/components/common/PanelLayout/PanelLayout.tsx